import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded';
import { useNavigate } from 'react-router-dom';
import { getCurrentMemberRank } from './communityPreviewData';

export const CommunityDashboardCard = () => {
  const navigate = useNavigate();
  const currentRank = getCurrentMemberRank();

  return (
    <button
      className="community-dashboard-card"
      type="button"
      onClick={() => navigate('/community')}
      aria-label="Open your weekly Community standing"
    >
      <span className="community-dashboard-card__icon" aria-hidden="true">
        <GroupsRoundedIcon />
      </span>
      <span className="community-dashboard-card__copy">
        <span className="community-dashboard-card__eyebrow">Community preview</span>
        <strong>Your weekly standing</strong>
        <span>Two active days have moved you into the top five.</span>
      </span>
      <span className="community-dashboard-card__rank">
        <span>
          <small>Weekly Circle</small>
          <strong>#{currentRank ?? '–'}</strong>
          <em>
            <TrendingUpRoundedIcon /> 3 this week
          </em>
        </span>
        <ArrowForwardRoundedIcon className="community-dashboard-card__arrow" />
      </span>
    </button>
  );
};
